/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/StarClubMainMenuTile',['pixi', 'absolute', 'lodash', 'Solitaire/SolitaireGameMode', 'MenuUI/MenuTile',
		'MenuUI/DailyChallengeProgressMeter', 'Solitaire/MvvmStructure/Service/SolitaireDailyChallengeService',
		'util/NineSliceWrapper', 'MenuUI/DropShadow'],

	function (PIXI, Absolute, _, SolitaireGameMode, MenuTile, DailyChallengeProgressMeter,
	          SolitaireDailyChallengeService, NineSliceWrapper, DropShadow) {

		var StarClubMainMenuTile = function (config, game) {
			var defaultConfig = {};
			this.initStarClubMainMenuTile(_.extend(defaultConfig, config), game);
		};

		StarClubMainMenuTile.prototype = Object.create(MenuTile.prototype);

		StarClubMainMenuTile.prototype.initStarClubMainMenuTile = function (config, game) {

			this.game = game;

			MenuTile.call(this, config);

			this.buildHeader();

			this.buildHoverGraphic();
			this.initImageOutline();
			this.positionTile();
			this.buildDropShadow();
		};

		StarClubMainMenuTile.prototype.buildHeader = function () {
			this.initHeaderBackground();
			this.initHeaderOutline();
			this.initHeaderShadow();
			this.initHeaderText();
			this.initImageShadow();
		};

		StarClubMainMenuTile.prototype.initHeaderBackground = function () {
			var header = new PIXI.Graphics();
			header.beginFill(0x204a8f, 1);
			header.drawRect(0, 0, this.image.width, Absolute.Coords.y(70));
			header.endFill();
			this.addChild(header);
			this.header = header;
		};

		StarClubMainMenuTile.prototype.initHeaderOutline = function () {
			var outLine = new PIXI.Graphics(),
				lineWeight = Absolute.Coords.x(1);
			outLine.beginFill(0xFFFFFF, 0);
			outLine.lineStyle(lineWeight, 0xffffff, 1);
			outLine.moveTo(0, this.header.height);
			outLine.lineTo(this.header.width, this.header.height);
			outLine.endFill();
			this.addChild(outLine);
		};

		StarClubMainMenuTile.prototype.initHeaderShadow = function () {
			var leftShadow = this.buildShadow(
				0, 0, this.header.width / 2, this.header.height, 0
				),
				rightShadow = this.buildShadow(
					this.header.width, this.header.height, this.header.width / 2, this.header.height, Math.PI
				);
			this.addChild(leftShadow);
			this.addChild(rightShadow);
		};

		StarClubMainMenuTile.prototype.initHeaderText = function () {
			var textStyle = {
					font: 'bold ' + Absolute.ScreenMetrics.getResScale() * 40 + "px Arial",
					fontFamily: 'segoeLight',
					fill: '#ffffff',
					align: 'left',
					strokeThickness: 2
				},
				text = new PIXI.Text(Absolute.StringManager('tiles.starClub').toUpperCase(), textStyle);
			text.anchor.set(0.5, 0.5);
			text.x = this.header.width / 2;
			text.y = this.header.height / 2 + Absolute.Coords.y(5);
			this.addChild(text);
		};

		StarClubMainMenuTile.prototype.initImageShadow = function () {
			var shadowWidth = this.image.width / 8,
				shadowHeight = this.image.height + this.header.height,
				leftShadow = this.buildShadow(0, 0, shadowWidth, shadowHeight, 0),
				rightShadow = this.buildShadow(
					this.image.width, shadowHeight, shadowWidth, shadowHeight, Math.PI
				);
			this.addChild(leftShadow);
			this.addChild(rightShadow);
		};

		StarClubMainMenuTile.prototype.buildShadow = function (x, y, width, height, rotation) {
			var shadow = new NineSliceWrapper(
				'mainmenu/shadow_stretch.png',
				width, height,
				5, 2, 5, 5);
			shadow.position.set(x, y);
			shadow.alpha = 1;
			shadow.rotation = rotation;
			return shadow;
		};

		StarClubMainMenuTile.prototype.buildHoverGraphic = function () {
			var hoverGraphic = new PIXI.Graphics(),
				lineWeight = Absolute.Coords.x(4);
			hoverGraphic.beginFill(0xFFFFFF, 0);
			hoverGraphic.lineStyle(lineWeight, 0xFFFFFF, 1);
			hoverGraphic.drawRect(0, 0, this.header.width, this.header.height + this.image.height);
			hoverGraphic.endFill();
			this.hover = hoverGraphic;
			this.hover.alpha = 0.01;
			this.addChild(this.hover)
		};

		StarClubMainMenuTile.prototype.initImageOutline = function () {
			var outLine = new PIXI.Graphics(),
				lineWeight = Absolute.Coords.x(1);
			outLine.beginFill(0xFFFFFF, 0);
			outLine.lineStyle(lineWeight, 0xffffff, 1);
			outLine.drawRect(0, 0, this.image.width, this.image.height + this.header.height);
			outLine.endFill();
			this.addChild(outLine);
			this.imageOutline = outLine;
		};

		StarClubMainMenuTile.prototype.positionTile = function () {
			this.image.y = this.header.y + this.header.height;
		};

		StarClubMainMenuTile.prototype.buildDropShadow = function () {
			if (this.dropShadow) this.removeChild(this.dropShadow);
			this.dropShadow = new DropShadow({
				baseWidth: this.image.width,
				baseHeight: this.image.height + this.header.height
			});
			this.addChildAt(this.dropShadow, 0);
		};

		StarClubMainMenuTile.prototype.updateStats = function () {

			SolitaireDailyChallengeService.GetChallengeSettingsForCurrentMonth(
				function (monthSettings) {
				}.bind(this),
				function () {
					Absolute.Debug.log("Error: GetChallengeSettingsForCurrentMonth()");
				}
			);
		};

		StarClubMainMenuTile.prototype.onShow = function () {

			this.interactive = true;

			if (SolitaireDailyChallengeService.HasCache() && SolitaireDailyChallengeService.IsValid()) {
				this.updateStats();
			}

		};

		return StarClubMainMenuTile;

	});

